import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { apiConfig } from '../../config'
import { getHeaders, ApiScope } from '../silentAuth'
import {  RunObjectTemplateCommand } from './types'
import { cacher } from "../rtkQueryCacheUtils";


// Define a service using a base URL and expected endpoints
export const objectsTemplatesApi = createApi({
  reducerPath: 'objectTemplatesApi',
  baseQuery: fetchBaseQuery({
    baseUrl: apiConfig.objectsTemplateApiUrl,
    prepareHeaders: async (headers, { getState }) => { return await getHeaders(ApiScope, headers); }
  }),
  tagTypes: [...cacher.defaultTags,'ObjectTemplates'],
  endpoints: (builder) => ({
    getObjectTemplates: builder.query<any[], void>({
      query: () => `/getobjectemplates`,
      providesTags: cacher.providesList('ObjectTemplates'),
  }),
    runObjectTemplate: builder.mutation<any, RunObjectTemplateCommand>({
      query: (args) => ({
        url: `${args.template}/run`,
        method: 'post',
        body: args
      }), 
    }),
  }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetObjectTemplatesQuery,
  useRunObjectTemplateMutation
} = objectsTemplatesApi
